<template>
    <div class='edit-unit'>
        <div class="unit">
            <el-tooltip class="item" :content="outTuxUnit" placement="top-start">
                <span>{{ outTuxUnit }}</span>
            </el-tooltip>
            <i @click="handleEdit" v-if="!readonly">编辑</i>
        </div>
        <el-dialog title="编辑参团单位" :visible.sync="dialogShow">
            <el-button type="primary" class="add-btn" @click="handleAdd">新增</el-button>
            <el-table :data="tableData" :cell-style="{ 'text-align': 'center' }" style="width: 100%;">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column property="name" label="参团单位名称">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isEdit" v-model="scope.row.rename"></el-input>
                        <span v-else>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140">
                    <template slot-scope="scope">
                        <el-button type="text" @click.native.prevent="handleRowEdit(scope.row)">
                            {{ scope.row.isEdit ? '保存' : '修改' }}</el-button>
                        <el-button type="text" v-if="scope.row.isEdit"
                            @click.native.prevent="handleRowCancel(scope.row, scope.$index)">取消</el-button>
                        <el-button class="del-btn" v-if="scope.row.name"
                            @click.native.prevent="handleRowDel(scope.$index)" type="text">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="footer">
                <el-button type="primary" @click="handleSave">保存</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        outTuxUnitList: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    components: {},
    data() {
        return {
            dialogShow: false,
            tableData: []
        }
    },
    computed: {
        outTuxUnit() {
            return this.outTuxUnitList.join(',')
        }
    },
    watch: {},
    methods: {
        //点击编辑
        handleEdit() {
            this.dialogShow = true;
            this.tableData = this.outTuxUnitList.map(item => {
                return {
                    name: item,
                    rename: item,
                    isEdit: false
                }
            })
        },
        //点击新增
        handleAdd() {
            this.tableData.push({
                name: '',
                rename: '',
                isEdit: true
            })
        },
        //点击行内保存/修改
        handleRowEdit(row) {
            if (row.isEdit) {
                //保存
                if (!row.rename) {
                    this.$message.error('参团单位名称不能为空')
                    return
                }
                row.name = row.rename;
                row.isEdit = false
            } else {
                row.isEdit = true
            }
        },
        //点击行内取消
        handleRowCancel(row, index) {
            if (!row.name) {
                this.tableData.splice(index, 1)
                return
            }
            row.rename = row.name;
            row.isEdit = false;
        },
        //点击行内删除
        handleRowDel(index) {
            this.tableData.splice(index, 1)
        },
        //点击保存
        handleSave() {
            const isEdit = this.tableData.find(item => item.isEdit)
            if (isEdit) {
                this.$message.error('请先保存修改中的参团单位')
                return
            }
            let arr = this.tableData.map(item => item.name).filter(item => item)
            this.$emit('save', arr, arr.join(','))
            this.dialogShow = false;
        },
        //点击取消
        handleCancel() {
            this.dialogShow = false;
        },
    },
    created() {
    },
    mounted() {
    },
}
</script>

<style scoped lang='scss'>
.edit-unit {
    .unit {
        display: flex;
        align-items: center;
        width: 100%;
    }

    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // flex:1;
        display: inline-block;
        max-width: calc(100% - 50px);
    }

    i {
        font-style: normal;
        color: #409EFF;
        cursor: pointer;
        margin-left: 10px;
        width: 40px;
    }

    .del-btn {
        color: #F56C6C;
    }

    .add-btn {
        margin-bottom: 10px;
    }
}
</style>